import { createSelector } from 'reselect'

const getCaseStudies = state => state.caseStudies

// Case studies are a list of collection, but only their first row
const getCaseStudyItemColour = data => {
  if (!data) return null
  const acf = data.get('acf')

  const firstSlide = acf && acf.get('slide') && acf.get('slide').first()
  const collectionBackgroundColour = acf.get('background_colour')
  const collectionSpreadBackgroundColour = firstSlide && firstSlide.get('slide_background_colour')
  const colourResult = collectionSpreadBackgroundColour || collectionBackgroundColour

  return {
    id: data.get('id'),
    colour: colourResult
  }
}

export const getCaseStudyColours = createSelector(
  [getCaseStudies],
  casestudies => {
    const data = casestudies.get('data')
    if (data) {
      const baseColour = {
        id: 'base',
        colour: '#F3F1ED'
      }
      const colourList = data.map(getCaseStudyItemColour)
      return colourList.insert(0, baseColour)
    } else return null
  }
)

// Case studies are a list of collection, but only their first row
const getCaseStudyItem = data => {
  if (!data) {
    return null
  }

  const acf = data.get('acf')

  // Check for mobile image and add to result if found
  const isMobileImageSwitch = acf && acf.get('mobile_image_switch')
  const mobileImage = isMobileImageSwitch && acf.getIn(['mobile_image', 'sizes', 'large'])

  return {
    id: data.get('id'),
    slug: data.get('slug'),
    subtitle: data.get('title').get('rendered'),
    title: (acf && acf.get('artist_name')) ? acf.get('artist_name').get('post_title') : '',
    slide: (acf && acf.get('slide')) ? acf.get('slide').first() : null,
    mobileImage: mobileImage
  }
}

export const getCaseStudyFetching = createSelector(
  [getCaseStudies],
  casestudies => casestudies.get('fetching')
)

export const getCaseStudyRows = createSelector(
  [getCaseStudies],
  casestudies => {
    const data = casestudies.get('data')
    return data ? data.map(getCaseStudyItem) : null
  }
)



// WEBPACK FOOTER //
// ./src/components/case-studies-container/selectors.js